import { render, staticRenderFns } from "./BuildSocialBlock.vue?vue&type=template&id=dfbb8acc&scoped=true&"
import script from "./BuildSocialBlock.vue?vue&type=script&lang=js&"
export * from "./BuildSocialBlock.vue?vue&type=script&lang=js&"
import style0 from "./BuildSocialBlock.vue?vue&type=style&index=0&id=dfbb8acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb8acc",
  null
  
)

export default component.exports